import React from 'react';
import RadioProps from '../../@types/Radio.type';
import './RadioComponent.scss';

const RadioComponent: React.FC<RadioProps> = ({
  componentName,
  label,
  value,
  checked,
  disabled,
}) => (
  // `undefined` omits the attribute: custom elements treat any present
  // `checked`/`disabled` attribute (even "false") as on.
  <auro-radio
    id={`basicGroup${componentName}Radio1`}
    label={label}
    name={componentName}
    value={value}
    checked={checked || undefined}
    disabled={disabled || undefined}
    data-testid={`radio-${label}`}
    role="radio"
  >
    <span>{label}</span>
  </auro-radio>
);

export default RadioComponent;
